// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__3oOB2","footerInner":"style_footerInner___mhaz","logo":"style_logo__DCVvC"};